export const GameState = {
  START: 'START',
  READY: 'READY',
  PLAYING: 'PLAYING',
  FALLING: 'FALLING',
  GAME_OVER: 'GAME_OVER',
  SCOREBOARD: 'SCOREBOARD',
  SETTINGS: 'SETTINGS'
};

export const WorldSpeed = {
  GROUND: 90,
  PIPES: 90
};
